import { Controller } from "stimulus";
import Rails from "@rails/ujs";

export default class extends Controller {
  static targets = ["content", "form"]

  static values = {
    originalText: String
  }

  toggleEditor() {
    this.formTarget.classList.remove('hidden');
    this.contentTarget.classList.add('hidden');

    let textArea = this._textArea();
    textArea.focus();
    textArea.selectionStart = textArea.value.length;

    let boundCancelEditing = this.cancelEditing.bind(this);
    document.dispatchEvent(new CustomEvent('promote:shortcuts--register', {
      detail: {
        key: 'Escape',
        group: 'card-title',
        handler: boundCancelEditing
      }
    }));
  }

  cancelEditing() {
    this.formTarget.classList.add('hidden');
    this.contentTarget.classList.remove('hidden');
    this._textArea().value = this.originalTextValue;

    document.dispatchEvent(new CustomEvent('promote:shortcuts--unregister', {
      detail: { group: 'card-title' }
    }));
  }

  submit(event) {
    event.preventDefault();

    this.formTarget.querySelector('.submit-button').click();
    this.formTarget.querySelector('.submit-button').disabled = true;
  }

  _textArea() {
    return this.formTarget.querySelector('.text-area-field');
  }
}
